import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * HubSpot Create List v1 Configuration Validator
 * Validates HubSpot list creation with list name
 */
export const Hubspot_Create_List_1_ConfigValidator = z.object({
    hubspotConnection: requiredString('HubSpot Connection is required'),
    listName: requiredString('List Name is required')
});
//# sourceMappingURL=hubspot-create-list-1.js.map